<template>
  <!-- 外发调度 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="clickBtnOperate({})"
          >多票派车</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="printBtns">打印</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="scope.row.dispatchStatus !== 'yi_pai_che:dispatch_status'"
                class="rbtns"
                @click.stop="clickBtnOperate(scope.row)"
                >单票派车</el-button
              >
              <el-button v-else class="rbtns" disabled
                >{{ scope.row.dispatchStatusShow || "" }}
                {{ scope.row.diaoduStateShow || "" }}</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- ======================打印组件======================== -->
    <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>
    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="调度配载模块"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleOk"
    ></printDialog>
    <!-- 创建和使用模板 -->
    <printSys
      :printForm="printForm"
      :title="printTitle"
      icon="el-icon-printer"
      @handleClose="handlePrintSysClose"
    >
      <printSysContent
        :printType="printType"
        :modelObj="modelObj"
        :modelClassName="modelClassName"
        :selectTableData="selectTableData"
      ></printSysContent>
    </printSys>
    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select v-model="modelClassName" placeholder style="width: 100%">
        <el-option
          v-for="(value, key) in classNameArr"
          :key="key"
          :label="value.name"
          :value="value.val"
        ></el-option>
      </el-select>
    </classNameDialog>
    <!-- ======================打印组件======================== -->

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
  </div>
</template>
<script>
import tableList from "@/pages/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, mixin_print, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "外发调度列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DispatchCar_OutgoingDispatch", //  页面标识
      reportFiledsNumber: "admin_waifa_dispatch_list", // 动态 条件、表头
      // 打印插件 每个页面不一样的
      // 模板className
      idarrs: [],
      classNameArr: [
        {
          name: "车辆成本付款清单",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminCarCostPrintDataV3tmsVo",
        },
        {
          name: "发车配载清单",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminDispatchPrintDataV3tmsVo",
        },
      ],
      // 默认的模板类型
      modelClassName: "",
    };
  },
  mounted() {},
  watch: {},
  methods: {
    clickBtnOperate(row) {
      let ids = [];
      if (row.waybillDispatchId) {
        ids = [row];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要操作的数据");
          return false;
        }
        ids = this.selectTableData;
        // waybillDispatchId
      }
      this.$router.push({
        path: "/DispatchCar/DispatchCar",
        query: {
          ids: JSON.stringify(ids),
        },
      });
    },
    // ==================打印插件==================
    // 打印按钮
    printEvent(val) {
      let idarr = [];
      if (val) {
        idarr.push(val.dispatchId);
        this.selectTableData = [val];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要打印的数据");
          return false;
        }
        idarr = this.selectTableData.map((item) => {
          return item.dispatchId;
        });
      }
      console.log("idarr", idarr);
      this.idarrs = idarr;

      window.sessionStorage.setItem(
        "set_PrintSelectTableData",
        JSON.stringify(idarr)
      );
      this.dialogFrom.dialogVisible = true;
    },
    // 打印预览模板
    handleView(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || [];
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }

      if (obj.className == this.classNameArr[0].val) {
        // 获取车辆成本打印数据
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // 打印-确定模板的数据
    handleOk(obj) {
      console.log(obj, "obj");
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || [];
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }
      if (obj.className == this.classNameArr[0].val) {
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // ==================打印插件==================
  },
};
</script>
<style scoped lang="less">
</style>